import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useAuthCheck = (requiredRole?: 'admin' | 'professor' | 'student') => {
  const { user, refreshAuth, loading: authContextLoading } = useAuth();
  const [authState, setAuthState] = useState({
    user: user,
    isLoading: true,
    isAuthenticated: false,
    isAuthorized: false,
    error: null as string | null,
  });

  const verifyAuth = useCallback(async () => {
    let currentUser = user;
    if (!currentUser) {
      try {
        currentUser = await refreshAuth();
      } catch (error) {
        console.error('[useAuthCheck] Verification error:', error);
        setAuthState({
          user: null,
          isLoading: false,
          isAuthenticated: false,
          isAuthorized: false,
          error: 'Verification failed',
        });
        return;
      }
    }

    const isAuth = !!currentUser;
    const isAuthorized = !requiredRole || (currentUser?.role === requiredRole);

    setAuthState({
      user: currentUser,
      isLoading: false,
      isAuthenticated: isAuth,
      isAuthorized,
      error: isAuth ? (isAuthorized ? null : 'Unauthorized') : 'Unauthenticated',
    });
  }, [user, requiredRole, refreshAuth]);

  useEffect(() => {
    if (!authContextLoading) {
      verifyAuth();
    }
  }, [authContextLoading, verifyAuth]);

  return authState;
};